export default "__VITE_ASSET__DBNSvw2d__"